import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
  inject,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mb-expandable-card-wrapper',
  templateUrl: './expandable-card-wrapper.component.html',
  styleUrls: ['./expandable-card-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class ExpandableCardWrapperComponent implements AfterViewInit {
  private cdr = inject(ChangeDetectorRef);

  @ViewChild('cardWrapper') cardWrapper!: ElementRef;

  @Input() showAll!: boolean;

  @Output() toggleWrapper = new EventEmitter<boolean>();

  public isExpandable = false;

  ngAfterViewInit(): void {
    const el = this.cardWrapper.nativeElement;
    this.isExpandable = el.scrollHeight > el.clientHeight || this.showAll;
    this.cdr.detectChanges();
  }

  public setCardWrapperState(): void {
    this.toggleWrapper.emit(!this.showAll);
  }
}
